"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeTime = exports.updateTime = exports.formatTime = exports.TIME_ANCHOR = exports.HOURS_IN_DAY = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var moment_1 = tslib_1.__importDefault(require("moment"));
exports.HOURS_IN_DAY = 24;
exports.TIME_ANCHOR = 30;
var TIME_FORMAT = "hh:mm A";
function formatTime(h, m, format) {
    return moment_1.default()
        .hours(h)
        .minutes(m)
        .format(format || TIME_FORMAT);
}
exports.formatTime = formatTime;
function updateTime(h, m) {
    var selectedTime = new Date();
    selectedTime.setHours(h);
    selectedTime.setMinutes(m);
    selectedTime.setSeconds(0);
    selectedTime.setMilliseconds(0);
    return selectedTime;
}
exports.updateTime = updateTime;
/**
 * @internal
 * export normalizeTime function for use outside this component
 * return 7:30 if time is 7:25
 * return 8:00 if time is 7:35
 * return 0:00 if time is 23:45
 */
function normalizeTime(time) {
    var h;
    var m;
    var hours = time.getHours();
    if (time.getMinutes() < exports.TIME_ANCHOR) {
        h = hours;
        m = exports.TIME_ANCHOR;
    }
    else {
        h = (hours + 1) % exports.HOURS_IN_DAY;
        m = 0;
    }
    return updateTime(h, m);
}
exports.normalizeTime = normalizeTime;
//# sourceMappingURL=timeUtilities.js.map